module.exports = __webpack_public_path__ + "img/Doc06-20160257-003_Site-No6_Illustration.d47ef664.jpg";